import { Injectable } from '@angular/core';
import { basicRoleFeatures, features } from '@app/core/startup/permission';
import { Auth } from '@app/interfaces/sys/auth';
import { Feature } from '@app/interfaces/sys/permission';
import { environment } from '@env/environment';
import { AuthHttp } from '@services/sys/auth.service';

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    login_url = '/login';

    constructor(private authService: AuthHttp) {
    }

    set(data: Auth): void {
        localStorage.setItem('tokenData', JSON.stringify(data));
    }

    get(): Auth {
        const info = localStorage.getItem('tokenData');
        return info ? JSON.parse(info) : null;
    }

    getToken(): string {
        const info = localStorage.getItem('tokenData');
        const userInfo: Auth = info ? JSON.parse(info) : null;
        return userInfo?.token;
    }

    clear(): void {
        localStorage.removeItem('tokenData');
    }

    async refresh(): Promise<void> {
        const data = await this.authService.current();
        this.set(data);
    }

    getUserPermissions(): string[] {
        const tokenData: Auth = this.get();
        const userPermissions = tokenData?.features ?? {};
        let allPermissions = {};
        const adminRole = 'Admin';
        if (tokenData?.roleNames.includes(adminRole)) {
            allPermissions = basicRoleFeatures[adminRole?.toLowerCase()]?.features ?? {};
        } else {
            allPermissions = {
                ...userPermissions,
            };
        }
        return allPermissions ? Object.keys(allPermissions) : [];
    }

    getAllFeatures(): Feature[] {
        const enablePages = environment.enablePages;
        return features.filter(item => !item.key || enablePages.includes(item.key));
    }

    getFeatures(featureItems: Feature[]): Feature[] {
        let data: Feature[] = [];
        featureItems.forEach((item) => {
            if (item.children) {
                data = data.concat(this.getFeatures(item.children));
            } else {
                data.push(item);
            }
        });
        return data;
    }

    isLabAdmin(): boolean {
        const tokenData = this.get();
        return tokenData.features['Dashboard View']?.some(x => x === 'All');
    }
}
